"use client";

import { ArrowLeft } from "react-iconly";
import { useRouter } from "next/navigation";

export function GoBack() {
  const router = useRouter();

  return (
    <button
      type="button"
      onClick={router.back}
      className="relative -bottom-10 max-md:hidden"
    >
      <ArrowLeft size={24} />
    </button>
  );
}
